import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedUser = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="user" size="100%" color={stroke ?? color} />
);

export { LineRoundedUser };
